/* eslint-disable */


/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */


if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;


      // Implantováno z funkčního kódu (Hlídač slev)
      this._lastVariantId = this.variant?.id ? String(this.variant.id) : null;
      this._lastIsOnSale = this.variant ? this.isVariantOnSale(this.variant) : false;


      this.addEventListener('change', this.handleVariantChange.bind(this));


      // Implantováno z funkčního kódu
      this.installSaleEnforcer();


      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
        
        // Implantováno z funkčního kódu - vynucení správné ceny a štítků při načtení
        this.updatePrice();
        this.applySaleState();
        this.enforceSaleStateBurst();
      });
    }


    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;


      if (this.variant) {
        // Implantováno z funkčního kódu
        this._lastVariantId = String(this.variant.id);
        this._lastIsOnSale = this.isVariantOnSale(this.variant);


        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      } else {
        // Implantováno z funkčního kódu
        this._lastVariantId = null;
        this._lastIsOnSale = false;
      }


      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);


      // Implantováno z funkčního kódu
      this.applySaleState();


      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }


      // Implantováno z funkčního kódu
      this.enforceSaleStateBurst();
    }


    // --- ZAČÁTEK NOVÝCH FUNKCÍ PRO ŠTÍTKY (z funkčního kódu) ---
    isVariantOnSale(variant) {
      const compare = Number(variant?.compare_at_price || 0);
      const price = Number(variant?.price || 0);
      return compare > price;
    }


    showElem(el) {
      if (!el) return;
      el.classList.remove('hide', 'hidden', 'visually-hidden');
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-hidden-by-regios-dopp');
    }


    hideElem(el) {
      if (!el) return;
      el.classList.add('hide', 'hidden', 'visually-hidden');
      el.setAttribute('hidden', 'true');
      el.setAttribute('aria-hidden', 'true');
    }


    ensureSaleLabelTextEl(saleLabelEl) {
      if (!saleLabelEl) return null;


      let textEl =
        saleLabelEl.querySelector('.product-label__text') ||
        saleLabelEl.querySelector('.js-sale-label-text');


      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'product-label__text js-sale-label-text';


        const svg = saleLabelEl.querySelector('svg');
        if (svg && svg.parentNode === saleLabelEl) {
          svg.insertAdjacentElement('afterend', textEl);
        } else {
          saleLabelEl.appendChild(textEl);
        }
      }


      Array.from(saleLabelEl.childNodes).forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '') {
          saleLabelEl.removeChild(n);
        }
      });


      return textEl;
    }


    applySaleState() {
      if (!this.section) return;
      if (!this.variant) return;


      const variantId = String(this.variant.id);
      const isOnSale = this.isVariantOnSale(this.variant);
      const isAvailable = !!this.variant.available;


      this._lastVariantId = variantId;
      this._lastIsOnSale = isOnSale;


      const variantLabelBlocks = this.section.querySelectorAll('.variant-label.js-variant-label');
      const activeBlock = this.section.querySelector(
        `.variant-label.js-variant-label[data-variant-id="${variantId}"]`
      );


      if (variantLabelBlocks.length) {
        variantLabelBlocks.forEach((el) => {
          const isActive = el.dataset.variantId === variantId;
          if (isActive) this.showElem(el);
          else this.hideElem(el);
        });
      }


      const priceRoot = this.section.querySelector('.product-info__price > .price');
      if (priceRoot) {
        const formatted = this.data?.formatted?.[this.variant.id] || {};
        const priceWasEl = priceRoot.querySelector('.price__was, .price_was');


        if (priceWasEl) {
          const wasValueEl = priceWasEl.querySelector('.js-value') || priceWasEl;


          const showWas = isOnSale && isAvailable;
          wasValueEl.innerHTML = showWas ? (formatted.compareAtPrice || '') : '';


          if (showWas) this.showElem(priceWasEl);
          else this.hideElem(priceWasEl);
        }


        priceRoot.classList.toggle('price--on-sale', isOnSale && isAvailable);
      }


      const allSaleLabels = this.section.querySelectorAll('.product-label--sale');
      allSaleLabels.forEach((el) => this.hideElem(el));


      let saleLabelEl = null;
      if (activeBlock) {
        saleLabelEl = activeBlock.querySelector('.product-label--sale');
      }
      if (!saleLabelEl) {
        saleLabelEl = this.section.querySelector('.product-label--sale');
      }


      const showSale = isOnSale && isAvailable;


      if (saleLabelEl) {
        if (showSale) {
          const compare = Number(this.variant.compare_at_price || 0);
          const priceNum = Number(this.variant.price || 0);
          const percent = compare > 0 ? Math.round((1 - priceNum / compare) * 100) : 0;


          const textEl = this.ensureSaleLabelTextEl(saleLabelEl);
          
          if (textEl) {
            // Přečte přeložené slovo z HTML atributu. Pokud tam z nějakého důvodu chybí, použije 'Sleva'.
            const saleWord = saleLabelEl.dataset.saleText || 'Sleva';
            textEl.textContent = `${saleWord} ${percent} %`;
          }
          
          // Old if (textEl) textEl.textContent = `Sleva ${percent} %.`;


          this.showElem(saleLabelEl);
        } else {
          this.hideElem(saleLabelEl);
        }
      }
    }


    enforceSaleStateBurst() {
      this.applySaleState();
      Promise.resolve().then(() => this.applySaleState());
      requestAnimationFrame(() => this.applySaleState());
      setTimeout(() => this.applySaleState(), 25);
      setTimeout(() => this.applySaleState(), 75);
      setTimeout(() => this.applySaleState(), 150);
      setTimeout(() => this.applySaleState(), 300);
    }


    installSaleEnforcer() {
      if (!this.section) return;
      if (this._saleObserverInstalled) return;
      this._saleObserverInstalled = true;


      let scheduled = false;
      const scheduleApply = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          if (this.variant) this.applySaleState();
        });
      };


      this._saleObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'childList') {
            scheduleApply();
            break;
          }
          if (m.type === 'attributes') {
            const el = m.target;
            if (!(el instanceof Element)) continue;


            const relevant =
              el.matches?.(
                '.product-label--sale, .price__was, .price_was, .variant-label.js-variant-label'
              ) ||
              el.closest?.('.product-info__price') ||
              el.closest?.('.variant-label.js-variant-label');


            if (
              relevant &&
              (m.attributeName === 'class' ||
                m.attributeName === 'hidden' ||
                m.attributeName === 'aria-hidden' ||
                m.attributeName === 'data-hidden-by-regios-dopp')
            ) {
              scheduleApply();
              break;
            }
          }
        }
      });


      this._saleObserver.observe(this.section, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'hidden', 'aria-hidden', 'data-hidden-by-regios-dopp']
      });
    }
    // --- KONEC NOVÝCH FUNKCÍ PRO ŠTÍTKY ---


    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }


    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;


      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;


      this.addBtn.disabled = !variantAvailable || this.preSelection;


      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {
        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }


    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);


      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');


        if (em) {
          em.hidden = available;
        }


        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }


    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;


      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }


      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });


        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;


            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });


            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });


              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }


    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;


      let hideBackorder = true;


      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];


        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;


          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }


      this.backorder.hidden = hideBackorder;
    }


    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;


      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;


      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }


    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;


      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;


        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }


    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;


      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }


    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;


      let { variant } = this;
      if (this.preSelection) {
        // pokud není vybraná varianta, použije se nejlevnější z produktu
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) {
            variant = this.data.product.variants[i];
          }
        }
      }


      if (this.variant) {
        const formatted = this.data.formatted[this.variant.id] || {};
        const priceCurrentEl = this.price.querySelector('.price__current');
        const unitPriceEl = this.price.querySelector('.unit-price');


        // aktuální cena
        if (priceCurrentEl) {
          const currentValueEl = priceCurrentEl.querySelector('.js-value') || priceCurrentEl;
          currentValueEl.innerHTML = formatted.price || '';
        }


        // unit price - zachováno z tvé dobré šablony
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;


          if (valueEl) valueEl.innerHTML = formatted.unitPrice || '';
          if (unitEl) unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }


        if (unitPriceEl) {
          unitPriceEl.hidden = !this.variant.unit_price_measurement;
        }


        // třída pro vyprodání (třídu pro slevu 'price--on-sale' teď řeší applySaleState)
        this.price.classList.toggle(
          'price--sold-out',
          !this.variant.available && !this.preSelection
        );
      }


      // bloky "default" vs "no-variant"
      const defaultEl = this.price.querySelector('.price__default');
      if (defaultEl) defaultEl.hidden = !this.variant && !this.preSelection;


      const noVariantEl = this.price.querySelector('.price__no-variant');
      if (noVariantEl) noVariantEl.hidden = this.variant || this.preSelection;


      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }


    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;


      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }


    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;


      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }


    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;


      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }


    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }


    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');


      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));


      });
    }


    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];


      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });


      return selectedOptions;
    }


    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }


    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }


  customElements.define('variant-picker', VariantPicker);
}